import { auth } from './auth'
import myserver from './getRequest'

myserver.parseRouter('auth', auth)
export default myserver
